import { render, staticRenderFns } from "./prospect.vue?vue&type=template&id=7d64eb22"
import script from "./prospect.vue?vue&type=script&lang=js"
export * from "./prospect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports